var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"congresses"}},[_c('div',{staticClass:"inner"},[_c('h1',[_vm._v("Vzdělávací akce")]),_c('congress-table')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }